/**
 * Helpers: Breakpoints
 * ------------------------------------------------------------------------------
 * - Standard breakpoints for each device.
 * - Values must match that of `$mq-breakpoints` in SCSS.
 */
/**
 * Breakpoint values
 * @example:
 *  import { values as breakpoints } from '...'
 */
export const values = {
  tiny: 320,
  small: 576,
  medium: 768,
  large: 1024,
  x_large: 1242,
  wide: 1440,
  x_wide: 1920,
}

/**
 * Breakpoint values with px.
 * @example:
 *  import breakpoints from '...'
 */
const breakpoints = {}

Object.keys(values).forEach((key) => {
  breakpoints[key] = `${values[key]}px`
})

export default breakpoints